import {
  IconCar16,
  IconHighway16,
  IconMetroEkb16,
  IconMetroKzn16,
  IconMetroMsk16,
  IconMetroNN16,
  IconMetroNovosib16,
  IconMetroSam16,
  IconMetroSpb16,
  IconWalk16,
  IconTrain16,
} from '@cian/ui-kit/icons';
import * as React from 'react';

import { ETransportType } from '../../repositories/search-offers.legacy/v2/types/NewbuildingSimilarBlockOfferForDesktopSchema';
import { INewbuildingSimilarOffer, INewbuildingSimilarOfferTransformed } from '../../types/newbuildingSimilarOffer';

const ICON_GRAY_HEX_COLOR = '#737a8e';

export const getUndergroundIcon = (undergroundType?: string | null): React.ReactNode => {
  switch (undergroundType) {
    case 'spb':
      return <IconMetroSpb16 color={'current_color'} />;
    case 'smr':
      return <IconMetroSam16 color={'current_color'} />;
    case 'ekb':
      return <IconMetroEkb16 color={'current_color'} />;
    case 'kzn':
      return <IconMetroKzn16 color={'current_color'} />;
    case 'nn':
      return <IconMetroNN16 color={'current_color'} />;
    case 'nsk':
      return <IconMetroNovosib16 color={'current_color'} />;
    default:
      return <IconMetroMsk16 color={'current_color'} />;
  }
};

export const mapNewbuildingSimilarOffers = (
  offers: INewbuildingSimilarOffer[],
): INewbuildingSimilarOfferTransformed[] => {
  return offers.reduce((acc, current) => {
    const {
      underground,
      highway,
      railway,
      floor,
      offerUrl,
      imageUrl,
      price,
      address,
      newbuildingName,
      totalArea,
      rootCount,
      analytics,
    } = current;
    const description = [`${rootCount} ･ `, `${totalArea} ･ `, floor];
    let locationText = null;
    let locationIconColor = null;
    let locationIcon = null;
    let timeText = null;
    let timeIcon = null;

    if (underground) {
      const isWalkingTime = underground.transportType === ETransportType.Walk;
      locationText = underground.name;
      locationIconColor = `#${underground.lineColor}`;
      locationIcon = getUndergroundIcon(underground.undergroundType);
      timeIcon = isWalkingTime ? <IconWalk16 color={'gray_icons_100'} /> : <IconCar16 color={'gray_icons_100'} />;
      timeText = `${underground.time} мин.`;
    } else if (highway) {
      locationText = highway.name;
      locationIconColor = ICON_GRAY_HEX_COLOR;
      locationIcon = <IconHighway16 color={'current_color'} />;
      timeText = highway.distance;
    } else if (railway) {
      locationText = railway.name;
      locationIconColor = ICON_GRAY_HEX_COLOR;
      locationIcon = <IconTrain16 color={'current_color'} />;
      timeText = railway.distance;
    }

    acc.push({
      title: newbuildingName,
      imageUrl,
      price,
      description,
      address,
      locationIcon,
      locationIconColor,
      locationText,
      timeIcon,
      timeText,
      url: offerUrl,
      product: analytics,
    });

    return acc;
  }, [] as INewbuildingSimilarOfferTransformed[]);
};
